import { Drawer } from 'antd';  
import { useState, useEffect } from 'react';

// SteppedDrawer component that handles step-based animations
const SteppedDrawer = ({ 
  open, 
  onClose, 
  step, 
  children, 
  title, 
  ...drawerProps 
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [previousStep, setPreviousStep] = useState(step);

  // Handle initial open state
  useEffect(() => {
    if (open) {
      setDrawerOpen(true);
    } else {
      setDrawerOpen(false);
    }
  }, [open]);

  // Handle step changes with animation
  useEffect(() => {
    if (step !== previousStep && open) {
      setDrawerOpen(false);
      
      // Wait for drawer to close, then reopen with new step
      setTimeout(() => {
        setDrawerOpen(true);
        setPreviousStep(step);
      }, 300);
    } else if (step === previousStep) {
      setPreviousStep(step);
    }
  }, [step, open, previousStep]);

  return (
    <Drawer
      {...drawerProps}
      open={drawerOpen}
      onClose={onClose}
      title={title}
    >
      {children}
    </Drawer>
  );
};

export default SteppedDrawer;
